export const handleImmixInput1Input = (
  setCamerasObject: any,
  camerasObject: any,
  inputString: any,
  objectId: number
) => {
  const newObject = camerasObject[objectId];

  newObject.immix.immix_input1 = inputString;

  setCamerasObject((previousState: any) => {
    return { ...previousState, objectId: newObject };
  });
};
